import React from 'react';
import './TafTooltip.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import PropTypes from 'prop-types';

import { OutsideAlerter } from '../OutsideClichHandler/OutsideClickHandler';

const propTypes = {
  handleInfoClick: PropTypes.func,
  isShown: PropTypes.bool,
  InfoText: PropTypes.elementType,
  position: PropTypes.instanceOf(Object),
};

const TafTooltip = ({ InfoText, handleInfoClick, isShown, position }) => (
  <>
    {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions */}
    <i className="fa tooltip position" onClick={handleInfoClick}><FontAwesomeIcon icon={faInfoCircle}/>
      {isShown &&
      <OutsideAlerter>
        <div
          className={`tooltipster tooltipster-base tooltipster-sidetip tooltipster-fade tooltipster-show tooltipster-right ${position.blockClass}`}
        >
          <div className="tooltipster-box">
            <div className="tooltipster-content">
              <InfoText/>
            </div>
          </div>
          <div className={`tooltipster-arrow ${position.arrowClass}`}>
            <div className="tooltipster-arrow-uncropped">
              <div className="tooltipster-arrow-border"/>
              <div className="tooltipster-arrow-background"/>
            </div>
          </div>
        </div>
      </OutsideAlerter>}
    </i>
  </>
);
TafTooltip.propTypes = propTypes;

export default TafTooltip;
